import { makeCall, Methods } from "../../utils/makeCall";
import { InquireBonusCodeErrors } from "./code.error";
import { ApiBonusCodeRecord } from "./code.entity";

export type InquireBonusCodeRequest = { code: string };
// export type InquireBonusCodeResponse = Pick<
//   ApiBonusCodeRecord,
//   "code" | "state" | "type" | "value" | "ad_id" | "exp_date"
// >;
export type InquireBonusCodeResponse = ApiBonusCodeRecord;

export const inquireBonusCode = makeCall<
  InquireBonusCodeRequest,
  InquireBonusCodeResponse,
  InquireBonusCodeErrors
>(Methods.InquireBonusCode);
